module.exports = __webpack_public_path__ + "img/float-btn-slot.e51a9e1c.svg";